import React from 'react';
import { NumberFormatValues, NumericFormat, SourceInfo } from 'react-number-format';
import { DECIMAL_SCALE, DECIMAL_SEPARATOR, THOUSAND_SEPARATOR } from './constants';

type NumberInputPropsType = {
    value: number | null;
    onValueChange: (value: NumberFormatValues, sourceInfo: SourceInfo) => void;
    disabled: boolean;
    className?: string;
    inputRef?: ((el: HTMLInputElement) => void) | React.Ref<any> | undefined;
    onFocus?: React.FocusEventHandler<HTMLInputElement>;
};

function NumberInput({ value, onValueChange, disabled, className = '', inputRef, onFocus }: NumberInputPropsType) {
    return (
        <NumericFormat
            getInputRef={inputRef}
            onFocus={onFocus}
            disabled={disabled}
            className={className}
            value={value ?? ''}
            allowNegative={true}
            decimalScale={DECIMAL_SCALE}
            decimalSeparator={DECIMAL_SEPARATOR}
            thousandSeparator={THOUSAND_SEPARATOR}
            onValueChange={onValueChange}
        />
    );
}

export default NumberInput;
